import { render, staticRenderFns } from "./CampaignSetting.vue?vue&type=template&id=2b9ff622"
import script from "./CampaignSetting.vue?vue&type=script&lang=js"
export * from "./CampaignSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports